// extracted by mini-css-extract-plugin
export default {"departments":"_G-z","departmentHeading":"aH-z","departmentSection":"bH-z","departmentName":"cH-z","departmentLink":"dH-z","expandIcon":"eH-z"};